import Page from "webPage/Page";

import {handleScrollingSection} from "util/scrolling-section";
import Quiz from "util/Quiz";

Page.register('page-template-quiz', () => {
    if ($('.js-quiz').length === 1) {
        new Quiz($('.js-quiz'));
    }

    handleScrollingSection($(".js-rating-track-wrap"), 0, 1199);
});
